import { handleSearchWordChange } from '../slice/product-complete-list.slice';
export const searchWordChangedEvent = handleSearchWordChange;
